import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

export const getIsRestrictedInLocation = (
  contest: Pick<Contest, 'is_allowed_in_location'>
): boolean => contest.is_allowed_in_location === false;
